import React from "react";
import { Switch, Route } from "react-router-dom";
import { DEALER_GROUP_REQUESTED_ACCEPT_ROUTE, DEALER_GROUP_REQUESTED_DECLINE_ROUTE } from "../../../constants/appRoutes";
import { AppManager } from "../../../manager";
import AcceptRequestPage from "./AcceptRequestPage/AcceptRequestPage";
import DeclineRequestPage from "./DeclineRequestPage/DeclineOrgInvitePage";

const DealerGroupRequestedPage = () => {
    return (
        <Switch>
            <Route exact path={DEALER_GROUP_REQUESTED_ACCEPT_ROUTE} component={() => <AcceptRequestPage />} />
            <Route exact path={DEALER_GROUP_REQUESTED_DECLINE_ROUTE} component={() => <DeclineRequestPage />} />
            <Route
                component={() => {
                    AppManager.route.gotoLogin();
                    return null;
                }}
            />
        </Switch>
    );
};

export default DealerGroupRequestedPage;
